<template>
  <EmdFormGroup
    :label="$t('recipients.create.email')"
    required
    :state="getState($v.recipient.email)"
    :feedbacks="feedbacks($v.recipient.email)"
  >
    <EmdInput
      v-if="canEdit"
      @input="() => $v.recipient.email.$touch()"
      type="email"
      v-model="recipient.email"
      name="email"
    />
    <span v-else>{{ recipient.email }}</span>
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { recipientValidationsGeneral } from '../validations'
export default {
  name: 'EmailInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    email: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  validations () {
    return { recipient: recipientValidationsGeneral }
  }
}
</script>
